/*
  '69': {
    name: 'Architectural Requests',
    includes: {
      '68': 'Homeowner Submissions',
      '70': 'Approval / Denial Workflows',
      '71': 'Communication Workflows'
    }
  }
*/

import { authFeatureGuard } from '@/router/auth-feature-guard'

export default [
  {
    path: '/architecturalRequests',
    name: 'architecturalRequests',
    component: () =>
      import(
        /* webpackChunkName: "architecturalRequests" */ '@/pages/Management/architectural/Requests/List.vue'
      ),
    beforeEnter: authFeatureGuard(69)
  },
  {
    path: '/architecturaltabs/:id',
    name: 'architecturaltabs',
    component: () =>
      import(
        /* webpackChunkName: "architecturalRequests" */ '@/pages/Shared/architecturalRequest/index.vue'
      ),
    beforeEnter: authFeatureGuard(69),
    children: [
      {
        path: 'architecturalRequestDetails',
        name: 'architectural.architecturalRequestDetails',
        component: () =>
          import(
            /* webpackChunkName: "architecturalRequests" */ '@/pages/Shared/architecturalRequest/Details/index.vue'
          )
      },
      {
        path: 'architecturalRequestDocuments',
        name: 'architectural.architecturalRequestDocuments',
        component: () =>
          import(
            /* webpackChunkName: "architecturalRequests" */ '@/pages/Shared/architecturalRequest/tabs/documents/List.vue'
          )
      },
      {
        path: 'architecturalRequestImages',
        name: 'architectural.architecturalRequestImages',
        component: () =>
          import(
            /* webpackChunkName: "architecturalRequests" */ '@/pages/Shared/architecturalRequest/tabs/photos/List.vue'
          )
      },
      {
        path: 'architecturalRequestVoteDetails',
        name: 'architectural.architecturalRequestVoteDetails',
        component: () =>
          import(
            /* webpackChunkName: "architecturalRequests" */ '@/pages/Shared/architecturalRequest/tabs/voteDetails/List.vue'
          )
      },
      {
        path: 'architecturalRequestConversations',
        name: 'architectural.architecturalRequestConversations',
        component: () =>
          import(
            /* webpackChunkName: "architecturalRequests" */ '@/pages/Shared/architecturalRequest/tabs/conversations/List.vue'
          )
      },
      {
        // If no tab is specifed, go to overview
        path: '',
        redirect: 'architecturalRequestDetails'
      },
      {
        // If path doesn't match, go to overview
        path: '*',
        redirect: 'architecturalRequestDetails'
      }
    ]
  }
]
